module.exports = __webpack_public_path__ + "static/scroll-logo-d14657bffd16aee9e7e98fc0104760cd.svg";